import { CustomAlert } from '../../common/_Utilities.jsx';
import moment 			from 'moment-timezone';

export function returnBDPStatus(submission) {
	let status = {type: '', icon: '', label: '', content: ''};

	if(submission.typeStage == "DRAFT") {
		status.type = "draft";
		status.label = "Draft";
		status.content = "Your submission is a draft. You may edit it and submit when it is ready.";
	}

	if(submission.typeStage == 'INTAKE' && submission.bPending == false && submission.bRejected == false) {
		status.type = "in-review";
		status.label = "In review";
		status.content = "Your submission is in the queue. You will receive a status update email once it has been reviewed.";
	}

	if(submission.bPending == true) {
		status.type = "resubmit";
		status.label = "Resubmit design";
		status.content = "<strong>Design Team has provided feedback</strong>. You may edit and resubmit.";
	}

	if(submission.typeStage == 'VALIDATION' && submission.bRejected == false) {
		status.type = "approved";
		status.icon = "fas fa-check";
		status.label = "Approved";
		status.content = "Congrats! Your design is approved to move forward to crowd vote phase.";
	}

	if(submission.typeStage == 'INTAKE' && submission.bRejected) {
		status.type = "not-approved";
		status.label = "Not approved";
		status.content = "Your design did not adhere to our Submission Guidelines and/or Terms of Service.";
	}

	if(submission.typeStage == 'FINALIST') {
		status.type = "finalist";
		status.icon = "fas fa-sparkles";
		status.label = "Finalist";
		status.content = "Congrats! Your design will move forward to crowdfunding.";
	}

	if(submission.typeStage == 'VALIDATION' && submission.bRejected) {
		status.type = "not-selected";
		status.label = "Not selected";
		status.content = "Your design was not chosen to move forward for crowdfunding.";
	}


	return status;
}

export function returnBDPStatusGroup(submission) {
	const status = returnBDPStatus(submission);

	return `<div class="bdp-status-group"><div class="bdp-status-group__icon bdp-status-tag bdp-status-tag--${status.type}">${status.icon ? `<i class="bdp-status-tag__icon ${status.icon}"></i>` : ''}${status.label}</div><p class="bdp-status-group__content">${status.content}</p></div>`;
}


export function clearMessageCount(idSubmission, cb){
	blapp.models.fetch
	(
		"_clearMessageCount"
	,	{
			controller:	"bdp.BLCBDPSubmission"
		,	method:		"clearMessageCount"
		,	params:		[idSubmission, "admin"]
		,	refresh:	true
		}
	).then(
		(data) =>
		{
			if(data == 'EC_OK'){
				if(cb)cb();
			}
			else{
				alert('Error clearing messages: '+data)
			}
			
		}
	).catch( 
		(err) =>
		{
			console.log(err)
			alert('Error clearing messages')
		}
	);
}

export async function returnBDPSubmissionState() {
	const resul = await getSeriesInfo(1)
	// const submissionStartDate = new Date('Jan 1, 2023 12:00:00').getTime();
	// const submissionEndDate = new Date('March 1, 2023 12:00:00').getTime();
	
	const submissionStartDate = resul.udtCrowdSourcingStart;
	const submissionEndDate = resul.udtCrowdSourcingEnd;
	const currentDate = blapp.config.server_time;
	const submissionClosed = submissionEndDate < currentDate;
	const submissionOpen = submissionStartDate < currentDate;
	
	return {startDate: submissionStartDate, endDate: submissionEndDate, closed: submissionClosed, open: submissionOpen};
}

async function getSeriesInfo(id) {
	let res = null;
	await blapp.models.fetch
	(
		"_getSeries"
	,	{
			controller:	"bdp.BLCBDPSeries"
		,	method:		"getSeries"
		,	params:		[1]
		,	refresh:	true
		}
	).then(
		(data) =>
		{
			if(data != null){
				res = data;
			}
			else{
				alert('Error : '+data)
			}
			
		}
	).catch( 
		(err) =>
		{
			console.log(err)
			alert('Error ')
		}
	);
	return res;
}

export function verifyAccount()
{
	const	me		= blapp.session.getMe();
	if ( me.statusBuyer == 1 )
	{
		triggerAlert( "Please confirm your email first!" );
		return false;
	}
	else if ( me.statusBuyer != 0 || me.statusSeller == 2 )
	{
		triggerAlert( "Your account is not in good standing. Cannot submit to this program.");
		return false;
	}

	return true;
}

export function bdpDateFormat(date) {
	return moment(date).tz('America/Los_Angeles').format('MMMM Do');
}

export function bdpDateFormatShort(date) {
	return moment(date).tz('America/Los_Angeles').format('MMM, YYYY');
}

export function bdpDateFormatLong(date) {
	return moment(date).tz('America/Los_Angeles').format('MMMM Do, YYYY [at] h A');
}

export function bdpDateFormatShortYear(date) {
	return moment(date).tz('America/Los_Angeles').format('MMMM Do, YYYY');
}

export function returnSeriesDates(sc) {
	const seriesDates = [
			{name: 'paletteAdded', dates: {start: sc.udtPaletteAdded}}
		, {name: 'crowdsourcing', dates: {start: sc.udtCrowdSourcingStart, end: sc.udtCrowdSourcingEnd}}
		, {name: 'validation', dates: {start: sc.udtCrowdValidationStart, end: sc.udtCrowdValidationEnd}}
		, {name: 'review', dates: {start: sc.udtReviewStart, end: sc.udtReviewEnd}}
		, {name: 'designsAnnounced', dates: {start: sc.udtDesignsAnnounced}}
		, {name: 'refining', dates: {start: sc.udtRefiningStart, end: sc.udtRefiningEnd}}
		,	{name: 'crowdfunding', dates: {start: sc.udtCrowdFundingStart, end: sc.udtCrowdFundingEnd}}
		, {name: 'productionStart', dates: {start: sc.udtProductionStart}}
	];

	return seriesDates;
}

function triggerAlert(message) {
	const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
	<p class="text-color--primaryRed">${message}</p>`;

	CustomAlert(confirmContent, 'Continue');
}